<template>
  <div>
    <div v-if="!isMobile">
      <div class="sticky" v-if="sticky">
        <table :class="{'table-loading':loading}">
          <thead>
            <th :class="{'sortable':true, 'active':currentOrder.field === 'name'}"
            @click="sort('name')">
            Name
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'name'"></i>
            </th>
            <th :class="{'sortable':true, 'active':currentOrder.field === 'promoCode'}"
            @click="sort('promoCode')">
            Promo Code
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'promoCode'"></i>
            </th>
            <th :class="{'sortable':true, 'active':currentOrder.field === 'amount'}"
            @click="sort('amount')">
            Credit Amount
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'amount'"></i>
            </th>
            <th :class="{'sortable':true, 'active':currentOrder.field === 'created'}"
            @click="sort('created')">
            Created Date
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'created'"></i>
            </th>
            <th :class="{'sortable':true, 'active':currentOrder.field === 'startDate'}"
            @click="sort('startDate')">
            Start Date
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'startDate'"></i>
            </th>
            <th :class="{'sortable':true, 'active':currentOrder.field === 'startDate'}"
            @click="sort('expirationDate')">
            Expiration Date
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'expirationDate'"></i>
            </th>
            <th>Total Codes</th>
            <th>Codes Used</th>
            <th>Codes Left</th>
            <th>Override Status</th>
            <th></th>
          </thead>
          <tbody>
            <tr v-for="promo in promos">
              <td><a :href="'/#/promo/' + promo.id" class="und" target="_blank">{{ promo.name }}</a></td>
              <td>{{ promo.promoCode }}</td>
              <td>${{ toFixed(promo.creditAmount) }}</td>
              <td>{{ promo.createdDate }}</td>
              <td>{{ promo.starDate }}</td>
              <td>{{ promo.expDate }}</td>
              <td>{{ promo.totalCodes }}</td>
              <td>{{ promo.codesUsed }}</td>
              <td>{{ promo.codesLeft }}</td>
              <td>
                <a v-if="promo.enabled" @click="deactivate(promo.id)" class="und">Deactivate</a>
                <a v-else @click="activate(promo.id)" class="und">Active</a>
              </td>
              <td>
                <a class="button cta xsmall success" @click="exportPromo(promo.id)">Export</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <table :class="{'table-loading':loading}">
        <thead>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'name'}"
          @click="sort('name')">
          Name
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'name'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'promoCode'}"
          @click="sort('promoCode')">
          Promo Code
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'promoCode'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'amount'}"
          @click="sort('amount')">
          Credit Amount
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'amount'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'created'}"
          @click="sort('created')">
          Created Date  
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'created'"></i>
          </th>     
          <th :class="{'sortable':true, 'active':currentOrder.field === 'startDate'}"
          @click="sort('startDate')">
          Start Date
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'startDate'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'startDate'}"
          @click="sort('expirationDate')">
          Expiration Date
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'expirationDate'"></i>
          </th>
          <th>Total Codes</th>
          <th>Codes Used</th>
          <th>Codes Left</th>
          <th>Override Status</th>
          <th></th>
        </thead>
        <tbody>
          <tr v-for="promo in promos">
            <td><a :href="'/#/promo/' + promo.id" class="und" target="_blank">{{ promo.name }}</a></td>
            <td>{{ promo.promoCode }}</td>
            <td>${{ toFixed(promo.creditAmount) }}</td>
            <td>{{ promo.createdDate }}</td>
            <td>{{ promo.starDate }}</td>
            <td>{{ promo.expDate }}</td>
            <td>{{ promo.totalCodes }}</td>
            <td>{{ promo.codesUsed }}</td>
            <td>{{ promo.codesLeft }}</td>
            <td>
              <a v-if="promo.enabled" @click="deactivate(promo.id)" class="und">Deactivate</a>
              <a v-else @click="activate(promo.id)" class="und">Active</a>
            </td>
            <td>
              <a class="button cta xsmall success" @click="exportPromo(promo.id)">Export</a>
            </td>
          </tr>

          <tr v-show="loading && !promos.length">
            <td class="table-block" colspan="11">
              <transition name="slide-up">
                <div class="loader" v-show="loading">
                  <div>
                    <i class="fas fa-spinner fa-spin"></i>
                    Loading...
                  </div>
                </div>
              </transition>
            </td>
          </tr>

          <tr v-show="!loading && !promos.length">
            <td colspan="11" class="table-block">
              <transition name="slide-up">
                <div v-show="promos.length === 0 && !loading" class="empty-result">
                  <i class="far fa-frown-open fa-3x"></i><br/>
                  No record found!
                </div>
              </transition>
            </td>
          </tr>

        </tbody>
      </table>
    </div>

    <div class="cards" v-else>
      <div v-show="loading && !promos.length">
        <transition name="slide-up">
          <div class="loader" v-show="loading">
            <div>
              <i class="fas fa-spinner fa-spin"></i>
              Loading...
            </div>
          </div>
        </transition>
      </div>

      <div v-show="!loading && !promos.length">
        <transition name="slide-up">
          <div v-show="promos.length === 0 && !loading" class="empty-result">
            <i class="far fa-frown-open fa-3x"></i><br/>
            No record found!
          </div>
        </transition>
      </div>
      <div class="card" v-for="promo in promos" :key="promo.id">
        <div class="card-info">
          <div class="card-header">
            <div class="title">
              <span class="name">{{promo.promoCode}}</span>
              <span class="amount">(${{ toFixed(promo.creditAmount) }})</span>
            </div>
            <div class="status">
              <a v-if="promo.enabled" @click="deactivate(promo.id)" class="und deactivate">Deactivate</a>
              <a v-else @click="activate(promo.id)" class="und activate">Active</a>
            </div>
          </div>
          <div class="title">
            <div class="label">Name: </div>
            <div class="value"><a :href="'/#/promo/' + promo.id" class="und" target="_blank">{{ promo.name }}</a></div>
          </div>
          <div class="title">
            <div class="label">Created Date: </div>
            <div class="value">{{promo.createdDate}}</div>
          </div>
          <div class="title">
            <div class="label">Start Date: </div>
            <div class="value">{{promo.starDate}}</div>
          </div>
          <div class="title">
            <div class="label">End Date: </div>
            <div class="value">{{promo.expDate}}</div>
          </div>
          <div class="title">
            <div class="label">Total Codes: </div>
            <div class="value">{{promo.totalCodes}}</div>
          </div>
          <div class="title">
            <div class="label">Codes Used: </div>
            <div class="value">{{promo.codesUsed}}</div>
          </div>
          <div class="title">
            <div class="label">Codes Left: </div>
            <div class="value">{{promo.codesLeft}}</div>
          </div>
          <div class="actions">
            <a class="button cta xsmall success" @click="exportPromo(promo.id)">Export</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CsvExport from 'csvexport'
import ApiPromo from '@/modules/api/promo'

const exporter = CsvExport.create({
  filename: 'export.csv',
  columns: [ '#', 'Promo Code', 'Status', 'Consumer ID', 'Redeemed Date', 'Expiration Date' ]
})

export default {
  name: 'promo-list',
  components: {},
  props: ['isMobile'],
  data () {
    return {
      promos: {},
      sticky: false
    }
  },
  computed: {
    _promo () { return this.$store.state.promo.list },
    loading () { return this.$store.state.promo.loading },
    _rerender () { return this.$store.state.promo.rerender },
    currentOrder () {
      let promo = this.$store.state.promo
      return { field: promo.order, asc: promo.orderAsc }
    }
  },
  methods: {
    toFixed (amount) { return parseFloat(amount).toFixed(2) },
    deactivate (id) {
      let self = this
      if (self.loading) { return }

      self.$store.commit('promo/setLoading', true)
      ApiPromo.deactivate(self, id, function (res) {
        self.$store.commit('promo/setLoading', false)
        if (!res.error) {
          self.$store.commit('promo/updateEnable', { id: id, enable: false })
          self.$store.commit('promo/setRerender', true)
        }
      })
    },
    activate (id) {
      let self = this
      if (self.loading) { return }

      self.$store.commit('promo/setLoading', true)
      ApiPromo.activate(self, id, function (res) {
        self.$store.commit('promo/setLoading', false)
        if (!res.error) {
          self.$store.commit('promo/updateEnable', { id: id, enable: true })
          self.$store.commit('promo/setRerender', true)
        }
      })
    },
    exportPromo (id) {
      let self = this
      ApiPromo.getViewListFull(self, id, function (res) {
        console.log('EXPORT', res)
        exporter.downloadCsv(res)
      })
    },
    onScroll () { this.sticky = window.pageYOffset > 160 },
    sort (field) {
      let self = this
      if (self.loading) { return }
      let promo = self.$store.state.promo
      if (field !== promo.order) {
        self.$store.commit('promo/setOrder', 1)
      } else {
        self.$store.commit('promo/setOrderAsc', promo.orderAsc === 1 ? 0 : 1)
      }
      self.$store.commit('promo/setOrder', field)

      self.$store.commit('promo/setLoading', true)
      ApiPromo.getList(self, {isNext: true}, function (res) {
        self.$store.commit('promo/setLoading', false)
      })
    }
  },
  watch: {
    _promo: function (value) { this.promos = value },
    _rerender: function (value) {
      if (value) {
        let self = this
        self.promos = ''
        self.$nextTick(() => { self.promos = self.$store.state.promo.list })
        self.$store.commit('promo/setRerender', false)
      }
    }
  },
  mounted () {
    let self = this
    window.onscroll = function () { self.onScroll() }
  }
}
</script>

<style lang="scss" scoped>
.sticky{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  height: 30px;
  z-index: 3;
}

table{
  border-collapse: collapse;
  width: 100%;
  transition: all .5s ease;
  margin-bottom: 50px;

  &.table-loading{ opacity: .7; }
  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
    .sortable{
      cursor: pointer;
      color: #333;
      text-decoration: underline;

      i{ margin-left: 2px; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      &:hover { background: #e3e7e8!important; }
      &:nth-of-type(even) { background: #fbfbfb; }
      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
      }
    }
  }

  input{
    display: inline-block;
    width: auto;
  }
  .type{
    display: inline-block;
    padding: 3px 6px;
    text-transform: uppercase;
    border-radius: 4px;
    color: #fff;
    font-size: 11px;
    font-weight: 600;

    &.tnc{ background: #2ab77c; }
    &.tcp{ background: #3f81a0; }
  }
  a{ cursor: pointer; }
  .und{ text-decoration: underline; }
  .date{ word-spacing: 5px; }
}

.loader{
  position: absolute;
  top:0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;

  div{
    position: absolute;
    top:50%;
    left: 0;
    width: 100%;
    transform: translateY(-50%);
    text-align: center;
  }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .4s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(15px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .cards {
    padding-bottom: 75px;
    .card {
      border: 1px solid #ccc;
      margin: 0 10px;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;

      > div {
        margin-bottom: 3px;
      }

      .card-info {
        padding: 10px;
        padding-bottom: 0;
  
        .card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 5px;
          .name {
            font-weight: 900;
          }
          .amount {
            margin-left: 5px;
            font-size: 14px;
          }
          .status {
            text-transform: uppercase;
            font-size: 14px;
            font-weight: 900;
            .und {
              &.deactivate {
                color: #ccc;
              } 
              text-decoration: underline; 
            }
          }
        }
  
        .title {
          display: flex;
          align-items: center;
        }
  
        .label {
          font-size: 12px;
          text-transform: uppercase;
          color: #bbb;
          font-weight: 600;
          margin-right: 5px;
        }
  
        .value {
          margin-right: 10px;
          font-size: 14px;
          font-weight: 900;
        }
      
      }
      .actions {
        width: 100%;
        background: #f3f3f3;
        border-top: 1px solid #ccc;
        padding: 15px 10px;
        text-align: center;
        margin-top: 15px;
        border-radius: 0 0 10px 10px;
        margin-bottom: 0;
        .button {
          line-height: 14px;
          font-size: 14px;
          padding: 10px 18px 9px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Promo/PromoList.vue